import ButtonGroup from '@jetbrains/ring-ui/components/button-group/button-group'
import classNames from 'classnames'
import {memo, useMemo} from 'react'

import {objectKeys} from '../../../utils/object'

import {StateOptions, BuildState} from './BuildStateFilter.constants'
import type {Props} from './BuildStateFilter.types'
import FilterButton from './FilterButton/FilterButton'

import styles from './BuildStateFilter.css'

function BuildStateFilter({
  className,
  activeState = BuildState.ALL,
  states,
  currentStates,
  ...restProps
}: Props) {
  const filteredStates = useMemo(
    () => objectKeys(StateOptions).filter(state => states.includes(state)),
    [states],
  )

  if (filteredStates.length === 0) {
    return null
  }

  return (
    <ButtonGroup className={className}>
      {filteredStates.map(state => {
        const {icon, title} = StateOptions[state]
        const isActive = state === activeState
        const isDisabled =
          state !== BuildState.ALL && currentStates?.size != null && !currentStates?.has(state)
        const buttonTitle = isDisabled ? `No ${title} builds` : title
        const buttonClasses = classNames({
          [styles.inactiveIcon]: icon != null && !isActive,
          [styles.disabledIcon]: icon != null && isDisabled,
        })

        return (
          <FilterButton
            {...restProps}
            key={state}
            className={buttonClasses}
            iconClassName={styles.stateIcon}
            state={state}
            icon={icon}
            title={buttonTitle}
            isDisabled={isDisabled}
            isActive={isActive}
          />
        )
      })}
    </ButtonGroup>
  )
}
export default memo<Props>(BuildStateFilter)
